import { render } from "./Inputs.vue?vue&type=template&id=ed16d8b8"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"

import "./Inputs.vue?vue&type=style&index=0&id=ed16d8b8&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__